import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { User } from '../models/user';
import { AuthService } from '../services/authService';
import { MealViewModel } from '../models/mealResponseModel';
import { AddFoodToPlanComponent } from '../add-food-to-plan/add-food-to-plan.component';

@Component({
  selector: 'app-meal-card-tabs',
  templateUrl: './meal-card-tabs.component.html',
  styleUrls: ['./meal-card-tabs.component.scss'],
  standalone: false
})
export class MealCardTabsComponent {
  @ViewChild(AddFoodToPlanComponent) addFoodToPlanComponent!: AddFoodToPlanComponent;
  @Input() mealType: string = '';
  @Input() mealViewModels: MealViewModel[] = [];
  @Output() mealViewModelsChange = new EventEmitter<MealViewModel[]>();
  @Output() mealTypeIdChange = new EventEmitter<number>();
  @Output() foodCreated = new EventEmitter<void>();
  user = new User('', false);
  mealTypeId: number = 0;

  constructor(private authService: AuthService) { }

  async ngOnInit() {
    const isLoggedIn = await this.checkIfUserIsLoggedIn();
    this.setMealTypeId();
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  onMealChange(mealViewModels: MealViewModel[]) {
    this.mealViewModels = mealViewModels;
    this.mealViewModelsChange.emit(this.mealViewModels); // Propagate changes up
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  private checkIfUserIsLoggedIn(): Promise<boolean> {
    return new Promise((resolve) => {
      this.authService.isLoggedIn().subscribe((response: any) => {
        this.user.loggedin = response.isAuthenticated;
        this.user.username = response.userName ?? "";
        resolve(this.user.loggedin);
      });
    });
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  public handleFoodAdded(): void {
    this.setMealTypeId();
    this.mealTypeIdChange.emit(this.mealTypeId);
  }

  public handleFoodCreated(): void {
    this.addFoodToPlanComponent.handleFoodCreated();
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  private setMealTypeId() {
    this.mealTypeId = 0;
    switch (this.mealType) {
      case "Breakfast":
        this.mealTypeId = 1;
        break;
      case "Lunch":
        this.mealTypeId = 2;
        break;
      case "Dinner":
        this.mealTypeId = 3;
        break;
      case "Snacks":
        this.mealTypeId = 4;
        break;
    }
  }
}
